import type { ReactElement } from 'react';
import Plan, { PlanName } from 'models/Plan';

type Props = { planName: PlanName; };

function PreselectedPlanBanner({ planName }: Props): ReactElement {
  const plan = new Plan(planName);

  return (
    <div className="c-alert">
      <div className="c-alert__text u-text--center">
        <div className="u-text--xl">
          Based on your answers, the plan that best fits your needs is
          the:
        </div>
        <div className="c-heading c-heading--brand-4">
          {plan.preselectedPlanMessage()}
        </div>
        <div>
          Don’t agree with our suggestion?
          {' '}
          <a href="/plans?f=3&amp;quiz=retake">Re-take Quiz</a>
        </div>
      </div>
    </div>
  );
}

export default PreselectedPlanBanner;
